import { BadgeType } from 'src/assets/colors';
import { GamstopStatusType } from './types';

export const convertGamstopStatusToBadgeType = (status: GamstopStatusType): BadgeType => {
    switch (status) {
        case 'Y':
            return 'dark-red';
        case 'P':
            return 'amber';
        case 'N':
            return 'dark-green';
        case 'unknown':
            return 'amber';
        case 'error':
            return 'amber';
        case 'loading':
            return 'gray';
        default:
            return 'dark-green';
    }
};
